import { ThunderboltOutlined, EditOutlined, CheckCircleFilled } from "@ant-design/icons";

/**
 * Bulk Email (2026-10-27): how this mail is written — a saved template, or "Custom": the
 * user's own message inside the company design. Two cards side by side, always visible, so
 * Custom is never buried in the template dropdown.
 */
const CARDS = [
  { key: "template", title: "Saved template", text: "Use a ready email", Icon: ThunderboltOutlined, tone: "#d97706" },
  { key: "custom", title: "Custom", text: "Your message in an email widget", Icon: EditOutlined, tone: "#5b48e8" },
];

export default function ComposeModeCards({ mode, onChange, customDisabled }) {
  return (
    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 20 }}>
      {CARDS.map(({ key, title, text, Icon, tone }) => {
        const active = mode === key;
        const disabled = key === "custom" && customDisabled;
        return (
          <button key={key} type="button" aria-pressed={active} disabled={disabled}
            onClick={() => !active && onChange(key)}
            style={{
              position: "relative", display: "flex", gap: 12, textAlign: "left",
              padding: "12px 34px 12px 14px", borderRadius: 12, alignItems: "center", cursor: disabled ? "not-allowed" : "pointer",
              border: `1.5px solid ${active ? tone : "#e5e7eb"}`,
              background: active ? `linear-gradient(135deg, ${tone}12, ${tone}05)` : "#fff",
              boxShadow: active ? `0 4px 14px ${tone}26` : "0 1px 2px rgba(0,0,0,0.04)",
              opacity: disabled ? 0.55 : 1, transition: "all 0.15s",
            }}>
            <span aria-hidden="true" style={{ width: 36, height: 36, borderRadius: 10, flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", background: active ? tone : `${tone}14`, color: active ? "#fff" : tone, fontSize: 16 }}>
              <Icon />
            </span>
            <span style={{ minWidth: 0 }}>
              <span style={{ display: "block", fontWeight: 700, fontSize: 14, color: "#1a1a2e", whiteSpace: "nowrap" }}>{title}</span>
              <span style={{ display: "block", fontSize: 12, color: disabled ? "#b45309" : "#6b7280", marginTop: 2 }}>
                {disabled ? "Ask an admin to add an email widget" : text}
              </span>
            </span>
            {active && <CheckCircleFilled aria-hidden="true" style={{ position: "absolute", top: 10, right: 10, color: tone, fontSize: 15 }} />}
          </button>
        );
      })}
    </div>
  );
}
